export default __webpack_public_path__ + "static/media/last.2da3ff34.jpg";